import isEqual from 'lodash/isEqual';

import { AugmentedStore } from 'ia-react-core/~/interfaces/AugmentedStore';
import { CoreAction } from 'ia-react-core/~/interfaces/CoreAction';

import get from '../../../utils/accessors/get';
import unset from '../../../utils/accessors/unset';

export default function cleanReducers<State extends object>(store: AugmentedStore<State>, state: State, action: CoreAction, changes: string[]) {
  if (!store.injectedReducers.cleanedReducers.length) {
    return state;
  }

  const cleanedState = store.injectedReducers.cleanedReducers.reduce<State>((latestState, cleanedReducer) => {
    const { key: currentKey, scope: currentScope = [], namespace } = cleanedReducer;

    const hasOtherOwner = (
      (
        namespace && store.injectedReducers.namespacedReducers[namespace].all.some((otherReducer) => (
          otherReducer.key === currentKey &&
          isEqual(otherReducer.scope, currentScope)
        ))
      ) || (
        !namespace && store.injectedReducers.unnamespacedReducers.some((otherReducer) => (
          otherReducer.key === currentKey &&
          isEqual(otherReducer.scope, currentScope)
        ))
      )
    );

    // A state may have an other owner when a reducer is currently being replace, which occurs when component is
    // unmounted and instantly remounted; in this case, we do not clean the state.
    if (hasOtherOwner) {
      return latestState;
    }

    const keyPath = currentKey.split('.');
    const statePath = [...currentScope, ...keyPath];
    const currentState = get(latestState, statePath);

    if (typeof currentState === 'undefined') {
      return latestState;
    }

    changes.push(statePath.join('.'));

    return unset(latestState, statePath) as State;
  }, state);

  // Init actions are passed without state, so it won't be possible to clean
  if (!action.type.startsWith('@@redux')) {
    store.injectedReducers.cleanedReducers.splice(0);
  }

  return cleanedState;
}
